<script setup lang="ts">
import PolicySummaryItem from "./PolicySummaryItem.vue";
import { useQuoteStore, useGlobalStore } from "@/stores";

const quote = useQuoteStore();
const global = useGlobalStore();
</script>

<template>
    <div class="cover-summary-container">
        <PolicySummaryItem
            title="Your Plan"
            value="Over 50s Fixed Life Insurance Plan"
            class="plan"
        />
        <PolicySummaryItem
            title="You will pay"
            :value="`£${quote.myPPM}`"
            subtitle="per month"
            class="result"
        />
        <PolicySummaryItem
            title="Your cash sum"
            :value="`£${global.formatNumber(quote.mySA)}`"
            class="sum"
        />
    </div>
</template>

<style scoped>
.plan {
    background: var(--grey-dark);
}

.result {
    background: var(--result-blue);
}

.sum {
    background: var(--sum-green);
}
</style>
